import { render, staticRenderFns } from "./MemberPrice.vue?vue&type=template&id=f79a341e"
import script from "./MemberPrice.vue?vue&type=script&lang=js"
export * from "./MemberPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MemberPrice.vue"
export default component.exports